module.exports = __webpack_public_path__ + "static/img/naked_chat.8728cd75.jpg";